export const config = {
    baseURL:"https://dif-v2.sinoep.com.mx/api/"
}
